// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__13Uii","file":"styles_file__3becj"};